import { render, staticRenderFns } from "./EmailLoginForm.vue?vue&type=template&id=9837637a"
import script from "./EmailLoginForm.vue?vue&type=script&lang=js"
export * from "./EmailLoginForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports